var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable complexity */
import React, { isValidElement } from 'react';
import AsyncCreatableSelect from 'react-select/async-creatable';
import { components } from 'react-select';
import debounce from 'debounce-promise';
import withStyles from '@material-ui/core/styles/withStyles';
import { withTheme } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import SearchIcon from '@material-ui/icons/Search';
import isUndefined from 'lodash/isUndefined';
export var MyTooltip = withStyles(function (theme) { return ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[6],
        fontSize: 11,
    },
    arrow: {
        color: theme.palette.common.white,
    },
}); })(Tooltip);
var MultiValueLabel = function (props) {
    var createTooltip = props.selectProps.createTooltip, data = props.data;
    var label = React.createElement(components.MultiValueLabel, __assign({}, props));
    if (!createTooltip)
        return label;
    var tooltip = createTooltip(data);
    var labelWithTooltip = (React.createElement(MyTooltip, { title: tooltip, placement: 'top', arrow: true },
        React.createElement("div", null,
            React.createElement(components.MultiValueLabel, __assign({}, props)))));
    return tooltip ? labelWithTooltip : label;
};
var PlaceHolder = function () { return (React.createElement("div", { style: { display: 'flex' } },
    React.createElement(SearchIcon, { fontSize: 'inherit' }),
    React.createElement("span", null, "(EMPTY)"))); };
// multiselect styles
var multiSelectStyle = {
    container: function (base) { return (__assign(__assign({}, base), { width: '100%' })); },
    dropdownIndicator: function () { return ({ display: 'none' }); },
    indicatorSeparator: function () { return ({ display: 'none' }); },
    multiValue: function (base, _a) {
        var _b = _a.selectProps, dark = _b.dark, muiTheme = _b.muiTheme, isFixed = _a.data.isFixed;
        var bg = dark ? muiTheme.palette.primary.dark : muiTheme.palette.primary.main;
        return __assign(__assign({}, base), { borderRadius: '3px', boxShadow: muiTheme.shadows[1] || '1px 1px 2px 1px #ccc', background: bg, color: muiTheme.palette.getContrastText(bg), paddingRight: isFixed ? '4px' : 'inherit' });
    },
    multiValueLabel: function (base, _a) {
        var _b = _a.selectProps, dark = _b.dark, muiTheme = _b.muiTheme;
        var bg = dark ? muiTheme.palette.primary.dark : muiTheme.palette.primary.main;
        return __assign(__assign({}, base), { background: bg, color: muiTheme.palette.getContrastText(bg) });
    },
    multiValueRemove: function (base, _a) {
        var isFixed = _a.data.isFixed;
        return (__assign(__assign({}, base), { display: isFixed ? 'none' : 'inherit' }));
    },
    control: function (base, _a) {
        var _b = _a.selectProps, muiTheme = _b.muiTheme, showBorder = _b.showBorder, isError = _b.isError;
        return (__assign(__assign({}, base), { borderStyle: showBorder ? 'solid' : 'none', borderColor: isError ? muiTheme.palette.error.main : base.borderColor, backgroundColor: isError ? muiTheme.palette.error[100] : base.backgroundColor, padding: '3px 0', minHeight: '18px', boxShadow: 'none', '&:hover': {
                borderColor: isError ? muiTheme.palette.error.main : base.borderColor,
            } }));
    },
    valueContainer: function (base) { return (__assign(__assign({}, base), { padding: 0 })); },
    input: function (base) { return (__assign(__assign({}, base), { padding: '0 2px', margin: '0' })); },
};
var isEditableInput = function (limit, value, disabled) {
    if (disabled)
        return false;
    if (!value || !limit)
        return true;
    return value.length < limit;
};
/**
 * @deprecated
 * Use `AsyncMultiSelectInput` to render a multiselect list with async option loading select-option.
 *
 * It is a wrapper for react-select. Please refer to https://react-select.com/home for more details
 *
 */
function AsyncMultiSelectInput(_a) {
    var loadOptions = _a.loadOptions, onChange = _a.onChange, value = _a.value, limit = _a.limit, name = _a.name, clearable = _a.clearable, disabled = _a.disabled, label = _a.label, showBorder = _a.showBorder, dark = _a.dark, cacheOptions = _a.cacheOptions, defaultOptions = _a.defaultOptions, createNewOption = _a.createNewOption, createTooltip = _a.createTooltip, portalTarget = _a.portalTarget, searchDelay = _a.searchDelay, theme = _a.theme, isError = _a.isError;
    var editableInput = isEditableInput(limit, value, disabled);
    var selectorOnChange = function (currentValues, _a) {
        var action = _a.action, removedValue = _a.removedValue;
        var modifiedValues = currentValues;
        switch (action) {
            case 'remove-value':
            case 'pop-value':
                if (removedValue.isFixed) {
                    // eslint-disable-next-line no-useless-return
                    return;
                }
                break;
            case 'clear':
                modifiedValues = value.filter(function (v) { return v.isFixed; });
                break;
            case 'create-option':
                modifiedValues = currentValues.map(function (option) {
                    if (!option.__isNew__) {
                        return option;
                    }
                    // eslint-disable-next-line no-param-reassign
                    delete option.__isNew__;
                    return createNewOption(option, action);
                });
                break;
            default:
                break;
        }
        onChange(modifiedValues);
    };
    return (React.createElement(React.Fragment, null,
        isValidElement(label) ? label : React.createElement("span", null, label),
        React.createElement(AsyncCreatableSelect, { value: value, isMulti: true, cacheOptions: cacheOptions, defaultOptions: defaultOptions, loadOptions: debounce(loadOptions || (function () { }), searchDelay), 
            // @ts-ignore The type defination of react select onChange is not complete. The removedValue is missing. Ignore it for now.
            onChange: selectorOnChange, name: name, components: {
                MultiValueLabel: MultiValueLabel,
                // Overriding the control element to inject a data-testid for testing
                Control: function (props) {
                    var innerProps = props.innerProps, innerRef = props.innerRef, children = props.children, getStyles = props.getStyles;
                    return (React.createElement("div", __assign({ "data-testid": 'asyncMultiSelectInputControl', style: getStyles('control', props) }, innerProps, { ref: innerRef }), children));
                },
            }, styles: multiSelectStyle, isSearchable: editableInput, openMenuOnClick: editableInput, isClearable: clearable, showBorder: showBorder, dark: dark, getOptionValue: function (option) { return option.label; }, createTooltip: createTooltip, placeholder: disabled ? '' : PlaceHolder(), menuPortalTarget: portalTarget, menuPlacement: !isUndefined(portalTarget) ? 'auto' : undefined, menuShouldScrollIntoView: false, muiTheme: theme, isError: isError })));
}
AsyncMultiSelectInput.defaultProps = {
    clearable: false,
    showBorder: false,
    dark: true,
    cacheOptions: true,
    defaultOptions: true,
    limit: 999,
    portalTarget: document.body,
    disabled: false,
    searchDelay: 800,
};
export default withTheme(AsyncMultiSelectInput);
//# sourceMappingURL=AsyncMultiselectInput.js.map